import Select from 'react-select';
import { useMemo } from 'react';

const selectStyles = {
  control: (base) => ({
    ...base,
    border: '1px solid #cccccc',
    borderRadius: '0.25rem',
    boxShadow: 'none',
    minHeight: '2rem',
    fontSize: '0.875rem',
    '&:hover': {
      border: '1px solid #cccccc',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#212121',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#212121',
    padding: '0 0.5rem 0 0',
    '&:hover': {
      color: '#000000',
    },
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
};

const TopicsFilter = ({
  isOpen,
  setIsOpen,
  allTags,
  geoTags,
  handleTopicClick,
  isMobile = false,
  isSidebar = false,
}) => {
  // Convert topics arrays to React Select options format
  const topicOptions = useMemo(() => {
    const regularTopics = allTags
      .map((topic) => ({
        value: topic,
        label:
          topic === 'public_safety'
            ? 'Public Safety'
            : topic
                .split('_')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' '),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    const locationTopics = geoTags
      .map((topic) => ({
        value: topic,
        label: topic
          .substring(3)
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' '),
        isLocation: true,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));

    // Group topics by regular/location
    return [
      { label: 'Topics', options: regularTopics },
      { label: 'Locations', options: locationTopics },
    ];
  }, [allTags, geoTags]);
  // Handle selection in React Select
  const handleSelectTopic = (option) => {
    if (option) {
      handleTopicClick(option.value);
    }
  };
  return (
    <div>
      <Select
        options={topicOptions}
        onChange={handleSelectTopic}
        placeholder={isSidebar ? 'Select topics' : 'Topics'}
        styles={selectStyles}
        isClearable={true}
        value={null}
        formatGroupLabel={(data) => (
          <div
            style={{
              color: '#666666',
              fontSize: '0.75rem',
              fontWeight: '700',
              textTransform: 'uppercase',
              padding: '0.5rem 0',
            }}
          >
            {data.label}
          </div>
        )}
      />
    </div>
  );
};

export default TopicsFilter;
